module.exports = __webpack_public_path__ + "static/media/queenMode.f027f1de.gif";